const reader = require('./reader');
const _ = require('underscore');
const SubtitleModel = require('../scopes/subtitle');

class ItemParser {
	constructor() {
		this.parseFromChanges = this.parseFromChanges.bind(this);
		this.parseSubtitle = this.parseSubtitle.bind(this);
	}

	parseFromChanges(item, changes, force) {
		changes = changes || {};
		changes.startTimeMilisec = changes.frameStart && reader.framesToMs(changes.frameStart);
		changes.endTimeMilisec = changes.frameEnd && reader.framesToMs(changes.frameEnd);

		let orgSubtitle = item.get('editStack').at(0);
		let orgStartTimeMilisec = reader.framesToMs(orgSubtitle.get('frameStart'));
		let orgEndTimeMilisec = reader.framesToMs(orgSubtitle.get('frameEnd'));
		let orgRow1 = orgSubtitle.get('row1');
		let orgRow2 = orgSubtitle.get('row2');
		let orgIsItalic = orgSubtitle.get('italic') ? orgSubtitle.get('italic') : false;

		let orgSubtitleData = {
			id: item.get('id'),
			translationId: item.get('translationId'),
			direction: 0,
			firstLine: orgRow1,
			secondLine: orgRow2,
			editType: SubtitleModel.VARIABLES.STATUSES.DEFAULT,
			startTimeMilisec: orgStartTimeMilisec,
			startTimeMilisecEdit: orgStartTimeMilisec,
			endTimeMilisec: orgEndTimeMilisec, //For now, in order to restore to default we need to set the editTime as the orignal time - hopefully will be changed in the near future
			endTimeMilisecEdit: orgEndTimeMilisec,
			isItalic: orgIsItalic,
			flag: false,
			hasBox: item.get('hasBox') ? true : false,
			position: localStorage.getItem('capNsub-player-progress')
		}

		let isChangesMatchOrgSubtitle = changes.startTimeMilisec == orgStartTimeMilisec &&
			changes.endTimeMilisec == orgEndTimeMilisec &&
			changes.row1 == orgRow1 &&
			changes.row2 == orgRow2 &&
			(changes.italic == undefined || changes.italic == orgIsItalic);

		if (isChangesMatchOrgSubtitle && !force) {
			return orgSubtitleData;
		}
		
		return _.extend(orgSubtitleData, {
			editType: changes.stauts || item.get('status'),
			firstLineEdit: changes.row1 ? changes.row1 : '',
			secondLineEdit: changes.row2 ? changes.row2 : '',
			startTimeMilisecEdit: changes.startTimeMilisec == null ? orgSubtitleData.startTimeMilisec : changes.startTimeMilisec,
			endTimeMilisecEdit: changes.endTimeMilisec == null ? orgSubtitleData.endTimeMilisec : changes.endTimeMilisec,
			isItalicEdit: changes.italic === undefined ?  orgIsItalic: !!changes.italic
		})
	}

	parseSubtitle(item, force) {
		let changes = {};

		if (item.get('editStackPosition') > 0) {
			let editedSubtitle = item.getCurrentModel();
			changes.startTimeMilisecEdit = reader.framesToMs(editedSubtitle.get('frameStart'));
			changes.endTimeMilisecEdit = reader.framesToMs(editedSubtitle.get('frameEnd'));
			changes.row1 = editedSubtitle.get('row1');
			changes.row2 = editedSubtitle.get('row2');
			changes.italic = editedSubtitle.get('italic');
			changes.translationId = editedSubtitle.get('translationId');
		}

		return this.parseFromChanges(item, changes, force)
	}

	parseForInsert(params) {
		if (!params.changes) {
			return this.parseSubtitle(params.item, params.force)
		}

		// Talhumy 9.1.2018: oren asked me that each new caption will be displayed as origianl (on the left side)
		// not like today where only new split subtitle is displayed on the left side

		// let isItemCreated = params.item.get('editStack').length >= 1;
		// if (isItemCreated) {
		// 	return this.parseFromChanges(params.item, params.changes, params.force);
		// }

		//Was used only for split
		return this.parseAsOriginalModel(params.item, params.changes);
	}

	parseAsOriginalModel(item, model) {
		return {
			id: null,
			translationId: model.translationId || item.get('translationId'),
			direction: 0,
			firstLine: model.row1,
			secondLine: model.row2,
			firstLineEdit: "",
			secondLineEdit: "",
			editType: item.get('status'),
			startTimeMilisec: reader.framesToMs(model.frameStart),
			endTimeMilisec: reader.framesToMs(model.frameEnd),
			startTimeMilisecEdit: reader.framesToMs(model.frameStart),
			endTimeMilisecEdit: reader.framesToMs(model.frameEnd),
			isItalic: false,
			isItalicEdit: false,
			flag: false,
			hasBox: item.get('hasBox') ? true : false,
			position: localStorage.getItem('capNsub-player-progress')
		};
	}
}

module.exports = new ItemParser();


// WEBPACK FOOTER //
// ./app/helpers/parser.js